








import { Component, Prop, Vue } from 'vue-property-decorator';
import { Constants } from '@/constants/constants';
import { CompetencyType } from '@/constants/competencyType.enum';
import { GEnum } from '@/constants/enum.defination';

@Component({
  name: 'GCompetencyLabel',
  computed: {},
  methods: {},
})
export default class GCompetencyLabel extends Vue {
  @Prop() competencyID: number;
  @Prop({ default: 'bottom' }) placement: string;

  get competencyType(): GEnum.CompetencyType {
    if (Constants.SelfCompetencyIDs.includes(this.competencyID)) {
      return GEnum.CompetencyType.Self;
    } else if (Constants.GiftCompetencyIDs.includes(this.competencyID)) {
      return GEnum.CompetencyType.Gift;
    } else if (Constants.CognitiveCompetencyIDs.includes(this.competencyID)) {
      return GEnum.CompetencyType.Cognitive;
    } else if (Constants.CommunityCompetencyIDs.includes(this.competencyID)) {
      return GEnum.CompetencyType.Community;
    }
  }

  get competencyTypeTooltip(): string {
    return CompetencyType.tooltipContent(this.competencyType);
  }

  get competencyBorderColorClass(): string {
    return CompetencyType.borderClass(this.competencyType);
  }

  get competencyTextColorClass(): string {
    return CompetencyType.textColorClass(this.competencyType);
  }
}
